'use strict';

import { asDateFilter } from './common-filters/as-date-filter';
import { asDatetimeFilter } from './common-filters/as-datetime-filter';

angular
  .module('common.filters', ['common.services', 'domain'])
  .filter('asDate', asDateFilter)
  .filter('asDatetime', asDatetimeFilter);
